import { useSetTimezone } from '@uplift/contexts';
import { useAllTimezonesQuery } from '@uplift/queries';
import { CalendarDateService } from '@uplift/services';
import { UserRole } from '@uplift/types';
import { useEffect } from 'react';

export const useUpliftTimezone = () => {
  const { data: timezones = [] } = useAllTimezonesQuery(UserRole.patient);
  const setTimezone = useSetTimezone();

  useEffect(() => {
    const localZone = CalendarDateService.date.tz.guess();
    const zone = timezones.find(x => x.ianaName === localZone);

    if (zone) {
      setTimezone(zone.ianaName);
    } else {
      setTimezone('America/New_York');
    }
  }, [ setTimezone, timezones ]);
};
